<template>
  <div>
    <div id="tm-sidebar-left" class="tm-sidebar-left scroller uk-text-center">                
        <h3 class="uk-heading-divider uk-margin-top shimmer">Choose type:</h3>                     
          <a @click="$emit('sidebarClick', 'full')">          
            <div id="sidebarTypeFull" class="design-type-boxes">
              <div class="uk-text-bold" style="border-bottom: 1px solid whitesmoke; width: 100%; color: #28A5F5; background: #F8F8F8;">
                Full Editor
              </div>             
              <div class="uk-padding-small">
                <img src="/img/illustrations/design_types/full_editor.svg" class="small-border" width="120px">
              </div>
            </div>
          </a>
         
          <a @click="$emit('sidebarClick', 'tiled')">
            <div id="sidebarTypeTile" class="design-type-boxes">
              <div class="uk-text-bold" style="border-bottom: 1px solid whitesmoke; width: 100%; color: #EAB126; background: #F8F8F8;">
                Tile
              </div>             
              <div class="uk-padding-small">
                <img src="/img/illustrations/design_types/tile.svg" class="small-border" width="120px">
              </div>
            </div>
          </a>   
         
          <a @click="$emit('sidebarClick', 'border')">
            <div id="sidebarTypeBorder" class="design-type-boxes">
              <div class="uk-text-bold" style="border-bottom: 1px solid whitesmoke; width: 100%; color: #F24C4E; background: #F8F8F8;">
                Border
              </div>             
              <div class="uk-padding-small">
                <img src="/img/illustrations/design_types/border.svg" class="small-border" width="120px">
              </div>
            </div>
          </a>   

          <a  @click="$emit('sidebarClick', 'banner')">
            <div class="design-type-boxes">
              <div class="uk-text-bold" style="border-bottom: 1px solid whitesmoke; width: 100%; color: #1FB58F; background: #F8F8F8;">
                Banner
              </div>             
              <div class="uk-padding-small">
                <img src="/img/illustrations/design_types/banner.svg" class="small-border" width="120px">
              </div>
            </div>
          </a>   

      </div>
   

  </div>

</template>

<script>
    export default {
        name: 'sidebar-design',
    }
</script>

<style scoped>
  .design-type-boxes {
    min-height: 100px;
    border-radius: 4px;
    border: 1px solid whitesmoke;
    box-shadow: 0 0 0 1px rgba(50,50,93,.08), 0 2px 5px 0 rgba(50,50,93,.06), 0 1px 1.5px 0 rgba(0,0,0,.05), 0 1px 2px 0 rgba(0,0,0,.06);                
    margin-bottom: 20px;
    background: white;
  }

  .design-type-boxes:hover {
    box-shadow: 0 0 0 1px rgba(50,50,93,.1), 0 2px 5px 0 rgba(50,50,93,.1), 0 3px 9px 0 rgba(50,50,93,.08), 0 1px 1.5px 0 rgba(0,0,0,.08), 0 1px 2px 0 rgba(0,0,0,.08); 
    
  }

  .small-border {
    box-shadow: 0 2px 2px 0 rgba(150, 150, 150, 0.14), 0 3px 1px -2px rgba(150, 150, 150, 0.14), 0 1px 5px 0 rgba(150, 150, 150, 0.14);
    border: 1px #A0A0A0 solid;
  }

  .uk-button-white:hover {
    background: white;
    box-shadow: 0 0 0 1px rgba(50,50,93,.1), 0 2px 5px 0 rgba(50,50,93,.1), 0 3px 9px 0 rgba(50,50,93,.08), 0 1px 1.5px 0 rgba(0,0,0,.08), 0 1px 2px 0 rgba(0,0,0,.08); 
  }

  .uk-card-active {
      outline: 2px solid #28a5f5;
  }

  .uk-placeholder {
      border: none;
  }

  .uk-panel .uk-padding-small {
      padding: 8px 10px 8px 10px;
  }

  a {
      text-decoration: none;
  }

  /* Shimmer Text */
  @-webkit-keyframes shimmer {
    0% {
      background-position: -5rem top;
    }
    70% {
      background-position: 50rem top;
    }
    100% {
      background-position: 50rem top;
    }
  }  

  .shimmer {
    background: #222 -webkit-linear-gradient(right, #222 0%, #a2a2a2 50%, #222 100%);
    background-position: -5rem top;
    background-repeat: no-repeat;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-animation-name: shimmer;
    -webkit-animation-duration: 2.4s;
    -webkit-animation-iteration-count: infinite;
    -webkit-background-size: 5rem 100%;    
  }  
</style>